module.exports = __webpack_public_path__ + "static/media/Rectangle Copy 2.7f2d8329.png";